import React, { useState } from 'react';
import { useEffect } from 'react';
import { FormControl, Typography, CircularProgress } from '@mui/material';
import { Card, CardContent } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import ComponentHeaderTitles from '../../ComponentHeaderTitles';
const ZakelijkeVragen = ({
    setIsFetchingData,
    chosenBuilding,
    setBuildingType,
    setOutput,
    onValidationChange,
    entiteit,
    }) => {
    const BACKEND_URL = "https://offerte.api.cleanenergy.nl/index?m=estimate";
    // Set the state to previously chosen building type, or to 'appartement' (the first option) if no building type was chosen yet
    const [woning, setWoning] = useState(chosenBuilding ? chosenBuilding : 'zzp');
    const [fetchingData, setFetchingData] = useState(false);
    // In case the api does not return a valid response, we want to set the output to a default value
    // this value is for an 'appartement' with 1 person
    const defaultOutput = {
        e_single: 1800,
        e_high: 1260,
        e_low: 540,
        gas: 800
    };

    const pandOptions = [
        { value: 'zzp', label: 'ZZP' },
        { value: 'eenmanszaak', label: 'Eenmanszaak' },
        { value: 'winkel', label: 'Winkel' },
        { value: 'kantoorpand', label: 'Kantoorpand' },
        { value: 'industrieel', label: 'Industrieel' },
    ];

    const pandIcons = {
        zzp: <div className="icon-as-zzp icon-size"></div>, // Vervang dit met je eigen icon component of markup
        eenmanszaak: <div className="icon-as-eenmanszaak icon-size"></div>,
        winkel: <div className="icon-as-winkel icon-size"></div>,
        kantoorpand: <div className="icon-as-kantoor icon-size"></div>,
        industrieel: <div className="icon-as-industrie icon-size"></div>,
    };

    const validateStepTwo = (woning) => {
        if (woning === "") {
            return [false, 'Selecteer het pand type'];
        }
        return [true, null];
    };

    const entity_is_business = (entiteit) => {
        if (entiteit === "Particulier") {
            return 0;
        }
        return 1;
    }

    const get_persons = () => {
        return 1;
    }


    async function get_data_from_api(buildingType) {
        const url = new URL(BACKEND_URL);
        const is_business = entity_is_business(entiteit);
        const persons = get_persons();
        const params = { m: "estimate", building_type: buildingType, household_size: persons, business: is_business };
        url.search = new URLSearchParams(params).toString();
        setFetchingData(true);
        setIsFetchingData(true);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        try {
            if (response.ok) {
                const data = await response.json();
                if (!validateApiResponse(data)) {
                    console.error('Error fetching usage estimate: invalid response', response);
                    setFetchingData(false);
                    setIsFetchingData(false);
                    return false;
                }
                setFetchingData(false);
                setIsFetchingData(false);
                return data;
            } else {
                console.error('Error getting usage estimate', response);
                setFetchingData(false);
                setIsFetchingData(false);
                return;
            }
        } catch (error) {
            console.error('Error getting usage estimate', error);
            setFetchingData(false);
            setIsFetchingData(false);
            return;
        }
    }


    const handleWoningChange = async (value) => {
        setWoning(value);
        setBuildingType(value);
        const [woningIsValid, woningErrorMessage] = validateStepTwo(value);
        onValidationChange({
            isValid: woningIsValid,
            errorMessage: woningErrorMessage
        });

        if (woningIsValid) {
            if (!fetchingData) {

                let data = await get_data_from_api(value);

                if (data) {
                    setOutput(data);
                    return;
                } else {
                    setOutput(defaultOutput);
                    return;
                }
            }
        } else {
            setOutput(defaultOutput);
            return;
        }

    };

    function validateApiResponse(data) {
        // we expect the api to respond with a json object with at least the following keys:
        // {
        //     "e_single": 2000,
        //     "e_high": 500,
        //     "e_low": 500,
        //     "gas": 900
        // }
        // if the response is not valid, we return false
        // if the response is valid, we return true
        if (data.e_single && data.e_high && data.e_low && data.gas) {
            return true;
        }
        return false;
    }


    // When the component mounts, we check if chosenBuilding has a value.
    // If it doesn't, we call setBuildingType with the default value.
    useEffect(() => {
        const fetchData = async () => {
            if (!chosenBuilding) {
                setBuildingType(woning);
                setWoning(woning);

                setFetchingData(true);
                setIsFetchingData(true);

                try {
                    let data = await get_data_from_api(woning);
                    setOutput(data || defaultOutput);
                } catch (error) {
                    console.error('Error fetching estimate:', error);
                    setFetchingData(false);
                    setIsFetchingData(false);
                    setOutput(defaultOutput);
                }

                setFetchingData(false);
                setIsFetchingData(false);
            }
        };

        fetchData();
    }, []); // Empty dependency array to ensure this only runs on mount


    return (
        <div>
            <ComponentHeaderTitles title="In wat voor pand zit je?"/>

            <FormControl component="fieldset" className='steps-rows'>
                <RadioGroup aria-label="woning" name="woning" value={woning}>
                    {pandOptions.map((option) => (
                        <Card
                        key={option.value}
                        onClick={() => handleWoningChange(option.value)}
                        className={woning === option.value ? "selected" : ""}
                        >
                            <CardContent>
                                <FormControlLabel
                                    value={option.value}
                                    control={<Radio disabled={fetchingData} />}
                                    label={
                                        <div className="icon-text-wrapper">
                                            {pandIcons[option.value]}
                                            <Typography variant="h6">
                                                {option.label}
                                            </Typography>
                                        </div>
                                    }
                                />
                            </CardContent>
                        </Card>
                    ))}
                </RadioGroup>
                {fetchingData && (
                <div className="spinner-container">
                <CircularProgress className='data-fetch-spinner' />
                </div>
            )}
            </FormControl>
        </div>
    );
};


ZakelijkeVragen.displayName = 'ZakelijkeVragen';
export default ZakelijkeVragen;
